import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby"
import { navigate } from "@reach/router"
import { Container, Row, Col } from "react-bootstrap";
import {  sortByList, index_name, leadooPageSlot } from '../../common/constant';
import { PageLinks } from "../../common/page-links";
import SelectDropDown from "../FilterBox/Sections/SelectDropDown"
import { propertyIntro } from "../../common/utils/property_utils";
import { startCase } from "lodash";
import { HeartIcon } from "../../common/icons"
import { SaveItem, savedSearchParams, UserObjectStoreProvider } from "@starberry/myaccount-website-utils";


import "./PropertyInfo.scss";

// Results count
//const Stats = ({ processingTimeMS, nbHits }) => <>{nbHits}</>

//const CustomStats = connectStats(Stats)

const site_name = process.env.GATSBY_SITE_NAME

const PropertyInfo = ({ algoliadata, onViewChange, location, searchState, searchParams, userObjects, sortByList, search_type }) => {

    var default_sort = sortByList.length > 0 ? sortByList[0].label : "Highest Price";
    var default_sort_val = sortByList.length > 0 ? sortByList[0].value : "HighestPrice";

    const [sort_by, setSortBy] = useState(default_sort);
    const [show_info, setShowInfo] = useState(false);

    // overwrite type, because search_type value set as type, also type value coming in propertyType params
    const saveSearchParams = savedSearchParams({...searchParams, type:searchParams?.propertyType || ''});

    //console.log("searchParams", searchParams, searchState);

    useEffect(() => {
        
        if (searchState?.sortBy) {
            var sortByVal = default_sort;
            if (searchState.sortBy === index_name + "_price_asc") {
                sortByVal = "Lowest Price";
            } else if (searchState.sortBy === index_name + "_newest") {
                sortByVal = "Newest";
            } else if (searchState.sortBy === index_name + "_oldest") {
                sortByVal = "Oldest";
            }
            setSortBy(sortByVal);
        }

    }, [searchState])


    const handleChange = (val) => {

        //console.log("default_sort_val", default_sort_val, val)
        var sort_path = "sortby-price-desc/";
        var location_path_remove = location.pathname.replace('sortby-price-desc/', '').replace('sortby-price-asc/', '').replace('sortby-newest/', '').replace('sortby-oldest/', '')

        if(default_sort_val === val){
            sort_path = "";
        } else{
            if (val === "HighestPrice") {
                sort_path = "sortby-price-desc/";
            } else if (val === "Newest") {
                sort_path = "sortby-newest/";
            } else if (val === "Oldest") {
                sort_path = "sortby-oldest/";
            } else {
                sort_path = "sortby-price-asc/";
            }
        }

        var search_url = location_path_remove + sort_path
        navigate(search_url, {state:location?.state})
    }

    //console.log("searchParams ==>", searchParams)

    const data = useStaticQuery(graphql`
        query PropertySearchQuery{
            glstrapi {
                propertySearch {
                    property_type {
                      id
                      label
                      value
                      department
                    }
                }
            }
        }
    `)

    var property_type_list = data.glstrapi.propertySearch.property_type;

    const intro = propertyIntro(searchParams, property_type_list);
    const metaIntro = propertyIntro({ ...searchParams, introCopy: true }, property_type_list);

    //console.log("metaIntro", searchParams);

    var area_name = searchParams?.areas ? searchParams?.areas : searchParams?.defaultArea;

    var pathname = search_type;

    return (
        <React.Fragment>
            <div className="property">
                <Container>
                    <Row>
                        <Col>
                            <UserObjectStoreProvider>
                            <div className="property-info">
                                <h1>{intro}</h1>
                                <div className="sm-details">
                                    <div className="count">
                                        <div className="save-search-wrap">
                                            {algoliadata?.total > 0 ? algoliadata?.total : 0} properties <i className="info-icon" onClick={() => setShowInfo(!show_info)}></i>
                                            <SaveItem type="search" searchParams={saveSearchParams} userObjects={userObjects}>
                                                <span className="save-search"><HeartIcon /><span>Save</span><span className="saved-text">d</span></span>
                                            </SaveItem>
                                        </div>
                                    </div>
                                    <div className="info-wrap">
                                        <div className="sort-by d-md-flex">
                                            <span className="sm-text">Sort by:</span>
                                            <SelectDropDown
                                                options={sortByList}
                                                placeholder={sort_by}
                                                className="react-select"
                                                classNamePrefix="react-select"
                                                handleChange={handleChange}
                                                selectedValue={sort_by ? sort_by : ""}
                                            />
                                        </div>
                                        <button className="map-info map-text" onClick={() => onViewChange(true)}>
                                            <i className=" icon-map"></i>
                                            Map View
                                        </button>
                                        <button className="map-info grid-text d-none" onClick={() => onViewChange(false)}>
                                            <i className="icon-list"></i>
                                            List View
                                        </button>
                                    </div>
                                </div>

                                {show_info && 
                                    <p className="info_text">Find the best {metaIntro} with <Link to={`/${PageLinks.branch_finder}/`}>{site_name} Estate Agents</Link>, or <Link to={`/${PageLinks.general_enquiry}/`}>contact</Link> our property experts and get help to find a property {searchParams.action} in {startCase(area_name)}.</p>
                                }

                            </div>
                            </UserObjectStoreProvider>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};
export default PropertyInfo;